/**
 * Onboarding must not redirect away until farewell TTS has revealed / finished
 * (or failed). Muted users have no held keys and leave immediately after complete.
 */
export function shouldLeaveOnboarding(input: {
  isComplete: boolean
  playbackPending: boolean
}): boolean {
  return input.isComplete && !input.playbackPending
}

/** UI can show the "session complete" panel once leave is allowed. */
export function shouldShowOnboardingCompletePanel(input: {
  isComplete: boolean
  playbackPending: boolean
}): boolean {
  return shouldLeaveOnboarding(input)
}
